import SkapaInlineMessage, { InlineMessageVariantEnum } from 'ui/InlineMessage/SkapaInlineMessage';
import InformationCircle from '@ingka/ssr-icon/paths/information-circle';
import { useIntl } from 'react-intl';
import Box from 'ui/Box';

export const InteriorSuggestionsLayoutMessage = () => {
  const { formatMessage } = useIntl();
  return (
    <Box pb="md" pt="md">
      <SkapaInlineMessage
        body={formatMessage({ id: 'storageone.interiorSuggestionLayoutMessage' })}
        variant={InlineMessageVariantEnum.INFORMATIVE}
        ssrIcon={InformationCircle}
        subtle
      />
    </Box>
  );
};
